<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('roles')"
                        :isNewButton="checkPermission('rolepermission_store')"
                        :isColumns="true"
                        @new-button-click="createFormShow()"
                        @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('permission')"
                              :isNewButton="checkPermission('rolepermission_store')"
                              :isColumns="true"
                              @new-button-click="createFormShow()"
                              @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="true"
                              @exportExcel="downloadExcel">
                <b-row>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('name')">
                            <b-form-input
                                v-model="datatable.queryParams.filter.name">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="8">
                        <b-form-group :label="$t('explanation')">
                            <b-form-input v-model="datatable.queryParams.filter.explanation">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>

            <CommonModal ref="showModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('role_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('permission_information').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>

            <CommonModal ref="createFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('role_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>

            <CommonModal ref="updateFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('role_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>

            <CommonModal ref="permissionFormModal" size="xxl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('rolepermission_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('role_permissions').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <permissions-update-form :formId="formId"
                                             @permissionFormSuccess="permissionFormSuccess"
                                             v-if="formProcess=='permission'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    // Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    // Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';

    // Services
    import RoleService from '@/services/RoleService';

    // Page
    import CreateForm from './CreateFrom';
    import UpdateForm from './UpdateForm';
    import ShowForm from './ShowForm';
    import PermissionsUpdateForm from './permissions/UpdateForm';

    // Other
    import qs from 'qs';
    import ClassroomService from "@/services/ClassroomService";

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            DatatableFilter,
            Datatable,
            CommonModal,

            ShowForm,
            CreateForm,
            UpdateForm,
            PermissionsUpdateForm
        },
        metaInfo() {
            return {
                title: this.$t('roles')
            };
        },
        data() {
            return {
                formId: null,
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'role_show',
                                    callback: (row) => {
                                        this.createFormShow(row.id);
                                    },
                                    show: () => {
                                        return this.checkPermission('role_update') ? false : true
                                    }
                                },
                                {
                                    text: this.$t('role_permissions'),
                                    class: 'ri-shield-flash-line',
                                    permission: 'role_show',
                                    callback: (row) => {
                                        this.permissionFormShow(row.id);
                                    },
                                    show: () => {
                                        return this.checkPermission('rolepermission_update')
                                    }
                                },
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line',
                                    permission: 'role_update',
                                    hidden: false,
                                    callback: (row) => {
                                        this.updateFormShow(row.id);
                                    },
                                    show: () => {
                                        return this.checkPermission('role_update')
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission: 'role_delete',
                                    hidden: false,
                                    callback: (row) => {
                                        this.delete(row.id);
                                    },
                                    show: () => {
                                        return this.checkPermission('role_delete') ? true : false
                                    }
                                }
                            ]
                        },
                        {
                            label: this.$t('id'),
                            field: 'id',
                            sortable: true
                        },
                        {
                            label: this.$t('name'),
                            field: 'name',
                            sortable: true
                        },
                        {
                            label: this.$t('explanation'),
                            field: 'explanation',
                            sortable: true
                        }

                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'name',
                        page: 1,
                        limit: 20
                    }
                }
            }
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return RoleService.getAll(config)
                                  .then((response) => {
                                      this.datatable.rows = response.data.data;
                                      this.datatable.total = response.data.pagination.total;
                                  })
                                  .finally(() => {
                                      this.datatable.isLoading = false;
                                  });
            },

            delete(id) {
                this.$swal
                    .fire({
                        text: this.$t('are_you_sure_to_delete'),
                        showCancelButton: true,
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no'),
                        icon: 'question'
                    })
                    .then((result) => {
                        RoleService.deleteRole(id)
                                   .then((response) => {
                                       this.filter();
                                       this.$toast.success(this.$t('api.' + response.data.message));
                                   })
                                   .catch((error) => {
                                       this.$toast.error(this.$t('api.' + error.data.message));
                                   });
                    });
            },

            // Form Clear
            formClear() {
                this.formId = null
                this.formProcess = null
            },

            // Show
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },

            // Create Form
            createFormShow() {
                this.formId = null
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },

            // Update Form
            updateFormShow(id) {
                this.formId = id
                this.formProcess = 'update'
                this.$refs.updateFormModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },

            // Update Form
            permissionFormShow(id) {
                this.formId = id
                this.formProcess = 'permission'
                this.$refs.permissionFormModal.$refs.commonModal.show()
            },
            permissionFormSuccess() {
                this.$refs.permissionFormModal.$refs.commonModal.hide()
                this.formClear()
            },
            downloadExcel(){
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                RoleService.downloadAsExcel(config)
                    .then(res => this._downloadFile(res, this.$t('roles') + '.xlsx'))
                    .catch(err => this.showErrors(err))
            }
        }
    }
</script>
